export function updateConfig(config) {
    return {
        type: 'UPDATE_Config',
        config: config
      }
}
